"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    isOtherOption: false,
    onClick: function () {
        /* do nothing */
    },
    onChange: function () {
        /* do nothing */
    },
    onKeyDown: function () {
        /* do nothing */
    },
    otherInputValue: '',
    selected: false,
    showText: true,
    hideCheckbox: false,
    disabled: false,
    subtext: '',
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map